import { gql } from '@apollo/client'
import { ArticoloTemplate } from 'components/template'
import { initializeApollo } from 'utils/apollo'
import { ARTICOLI_MAGAZINE, ARTICOLO_MAGAZINE } from 'utils/queries'
import { NextWrapper } from '../../data-fetching-wrapper'
import { useContentPagebuilder } from '../../utils/hooks'
import { getPlaceholder } from 'utils'

function Detail({ articolo, content, pagina }) {
  const contentSelected = useContentPagebuilder(
    {
      key: 'content',
      contentTypeId: articolo.contentTypeId,
      objectId: articolo.pk,
    },
    content
  )

  return <ArticoloTemplate articolo={articolo} content={contentSelected} pagina={pagina} />
}

export async function getStaticPaths() {
  const client = initializeApollo()

  const {
    data: { articoliMagazine },
  } = await client.query({
    query: ARTICOLI_MAGAZINE,
  })

  const paths = articoliMagazine.edges.map((x) => ({
    params: { slug: x.node.slug },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData }) => {
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const client = initializeApollo()

    const {
      data: { articoloMagazine },
    } = await client.query({
      query: ARTICOLO_MAGAZINE,
      variables: {
        slug: slug,
        preview: preview,
      },
      context: {
        headers,
      },
    })

    if (!articoloMagazine) {
      return {
        notFound: true,
      }
    }

    const placeholderParams = {
      key: 'content',
      contentTypeId: articoloMagazine.contentTypeId,
      objectId: articoloMagazine.pk,
      headers,
    }
    const content = await getPlaceholder(placeholderParams)

    const {
      data: { pagina },
    } = await client.query({
      query: gql`
      query {
        pagina(chiave: "magazine-detail", contentTypeId: ${articoloMagazine.contentTypeId}, objectId: ${articoloMagazine.pk}) {
          breadcrumbs {
            titolo
            url
          }
          seo {
            title
            description
            image
          }
          chiave
        }
      }
    `,
    })

    return {
      props: {
        articolo: articoloMagazine,
        content,
        pagina,
        key: articoloMagazine.pk,
        item: {
          pubblicato: articoloMagazine.pubblicato,
          visibilitaDal: articoloMagazine.publicationDate,
          visibilitaAl: null,
          visibile: articoloMagazine.visibile,
        },
      },
      revalidate: 60 * 5,
    }
  },
  'magazine/[slug]'
)

export default Detail
